// ============================================================
// FARMA STORE — Configurazione centrale dei contenuti
// Modifica SOLO questo file per aggiornare contatti, brand,
// servizi e promozioni, senza toccare il layout del sito.
// ============================================================

export const SITE = {
  name: "Farma Store",
  tagline: "Parafarmacia e Servizi",
  address: "Via Casilina 193, 03030 Castrocielo (FR)",
  addressShort: "Via Casilina 193 · Castrocielo",
  city: "Castrocielo",
  province: "FR",

  // ---------------------------------------------------------------
  // WHATSAPP — numero reale Farma Store (formato internazionale)
  // ---------------------------------------------------------------
  whatsappNumber: "393514528948",
  whatsappMessage: "Ciao, vorrei avere un\u2019informazione da Farma Store.",

  // TELEFONO FISSO — inserire il numero reale (es. "+39 0776 000000").
  // Lasciare null per non mostrarlo sul sito.
  phone: null,

  // ORARI DI APERTURA
  openingHours: [
    { days: "Lunedì – Sabato", hours: "8:30 – 13:00 · 16:00 – 20:00" },
  ],
};

// Dati legali — Farma Store è un marchio registrato di Nutralis S.r.l.
export const LEGAL = {
  company: "Nutralis S.r.l.",
  legalAddress: "Via Domenico Torriero 29, 03038 Roccasecca (FR)",
  vat: "03300400607",
};

export const waLink = (message = SITE.whatsappMessage) =>
  `https://wa.me/${SITE.whatsappNumber}?text=${encodeURIComponent(message)}`;

export const mapsDirectionsUrl = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(
  "Farma Store, Via Casilina 193, 03030 Castrocielo FR"
)}`;

export const mapsEmbedUrl = `https://www.google.com/maps?q=${encodeURIComponent(
  "Farma Store Parafarmacia, Via Casilina 193, Castrocielo, FR, Italia"
)}&output=embed`;

export const NAV_LINKS = [
  { id: "home", label: "Home", href: "#home" },
  { id: "chi-siamo", label: "Chi siamo", href: "#chi-siamo" },
  { id: "brand", label: "Brand", href: "#brand" },
  { id: "servizi", label: "Servizi", href: "#servizi" },
  { id: "promo", label: "Promo", href: "#promo" },
  { id: "contatti", label: "Contatti", href: "#contatti" },
];

// Immagini: foto reali del negozio (hero, chi siamo) + visual editoriali
// per la sezione dermocosmesi (sostituibili con foto reali quando disponibili).
export const IMAGES = {
  hero: {
    src: "/images/esterno.webp",
    alt: "L'esterno di Farma Store in Via Casilina 193 a Castrocielo",
  },
  dermo: {
    src: "https://images.unsplash.com/photo-1774348599868-8e4bec62eafe?auto=format&fit=crop&w=1200&q=80",
    alt: "Cura della pelle con prodotti dermocosmetici",
  },
  dermoDetail: {
    src: "https://images.unsplash.com/photo-1640059561069-03205e5eda38?auto=format&fit=crop&w=800&q=80",
    alt: "Dettaglio botanico legato al benessere naturale",
  },
  about: {
    src: "/images/team.webp",
    alt: "Il team di Farma Store al banco della parafarmacia",
  },
};

export const VALUE_PROPS = [
  {
    id: "consiglio",
    icon: "MessageSquareText",
    title: "Consiglio professionale",
    text: "Ti aiutiamo a trovare la soluzione più adatta alle tue esigenze.",
  },
  {
    id: "selezione",
    icon: "ListChecks",
    title: "Selezione accurata",
    text: "Dermocosmesi, integrazione e benessere scelti con attenzione.",
  },
  {
    id: "rapporto",
    icon: "HeartHandshake",
    title: "Un rapporto personale",
    text: "Non solo prodotti: ascolto, consulenza e attenzione alla persona.",
  },
];

export const BRANDS = [
  "NUXE",
  "SVR",
  "ISDIN",
  "Weleda",
  "Menarini",
];

export const SERVICES = [
  {
    id: "bia",
    icon: "Activity",
    title: "Analisi della composizione corporea BIA",
    text: "Valutazione della composizione corporea attraverso analisi bioimpedenziometrica.",
    message: "Ciao, vorrei informazioni sull\u2019analisi BIA da Farma Store.",
  },
  {
    id: "nutrizione",
    icon: "Salad",
    title: "Consulenza nutrizionale",
    text: "Percorsi e consulenze dedicate al benessere e all\u2019alimentazione.",
    message: "Ciao, vorrei informazioni sulla consulenza nutrizionale da Farma Store.",
  },
  {
    id: "dermo",
    icon: "Sparkles",
    title: "Consulenza dermocosmetica",
    text: "Aiuto nella scelta della routine e dei prodotti più indicati per la pelle.",
    message: "Ciao, vorrei prenotare una consulenza dermocosmetica da Farma Store.",
  },
  {
    id: "cabina",
    icon: "Flower2",
    title: "Cabina estetica",
    text: "Uno spazio dedicato a trattamenti e servizi estetici professionali.",
    message: "Ciao, vorrei informazioni sulla cabina estetica di Farma Store.",
  },
];

// ---------------------------------------------------------------
// PROMOZIONI — modifica titolo, testo, tag e immagine (opzionale)
// direttamente qui. image: null mostra un segnaposto elegante.
// ---------------------------------------------------------------
export const PROMOS = [
  {
    id: "promo-dermocosmesi",
    tag: "In evidenza",
    title: "Promo Dermocosmesi",
    text: "Scopri le iniziative del momento dedicate ai nostri brand.",
    image: "/images/promo-svr.png",
  },
  {
    id: "novita",
    tag: "Appena arrivate",
    title: "Novità in negozio",
    text: "Nuovi prodotti e trattamenti selezionati per te.",
    image: "/images/novita-nuxe.webp",
  },
  {
    id: "eventi",
    tag: "Appuntamenti",
    title: "Cabina estetica & giornate speciali",
    text: "Trattamenti estetici, consulenze ed eventi dedicati al benessere.",
    image: "/images/cabina-estetica.webp",
  },
];
